"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License. See License.txt in the project root for license information.
Object.defineProperty(exports, "__esModule", {
  value: true
});
var azureServiceClient_1 = require("./azureServiceClient");
exports.AzureServiceClient = azureServiceClient_1.AzureServiceClient;
var constants_1 = require("./util/constants");
exports.Constants = constants_1.default;
var cloudError_1 = require("./cloudError");
exports.CloudErrorMapper = cloudError_1.CloudErrorMapper;
var baseResource_1 = require("./baseResource");
exports.BaseResourceMapper = baseResource_1.BaseResourceMapper;
var cognitiveServicesCredentials_1 = require("./credentials/cognitiveServicesCredentials");
exports.CognitiveServicesCredentials = cognitiveServicesCredentials_1.CognitiveServicesCredentials;